import { onMounted, ref } from "@vue/composition-api"
import { project, dashboardDetail } from '../api/index';
import { handleErrorMessageToast, handleWarningMessageToast } from '@/common/util';
import { tabItemType, tabListData } from '../types';

export function useIndexModel() {
    const tabList = ref<tabItemType[]>(tabListData);
    const tabActive = ref(tabListData[0].dashboardCode);

    async function getProject()  {
        // 因为数图返回的dashboard list不能排序；也有可能当前空间里dashboard不在此需求里展示，
        // 所以不再直接渲染返回结构，暂时在代码内写死，后续可考虑迁移至kconf
        tabList.value = tabListData;
        tabActive.value = tabList.value[0].dashboardCode; // 默认选中第一个tab
        return;
        // try {
        //     const res = await project('miniGame');
        //     tabList.value = res.data.data.dashboards;
        //     tabActive.value = tabList.value[0].dashboardCode; // 默认选中第一个tab
        // } catch(error) {
        //     handleErrorMessageToast(error.error_msg || '系统异常，请稍后再试')
        // }
    }

    return {
        tabList,
        tabActive,
        getProject
    }
}
